import { PodsList } from './PodsList'

export default {
  PodsList,
}
